<template>
  <div :key="key" class="animated fadeIn brief-datos-cambios">
    <div class="cambios" v-for="(cambio, index) in cambios" :key="cambio.id">
      <p class="titulo">Solicitud de Cambios Nro. {{ cambios.length - index }}</p>
      <p class="titulo">{{ cambio.fechaUltimaEdicion | fechaHora }} - {{ cambio.usuario }}</p>
      <p class="titulo" v-if="existsfechaEntregaSolicitada(cambio.fechaEntrega)">Fecha Entrega Solicitada: {{ cambio.fechaEntrega | fechaHora }}</p>
      <p class="cambios">{{ cambio.cambios }}</p>

      <template v-if="cambio.imagenes">
        <b-row class="galeria-imagenes">
          <b-col cols="12" md="3" v-for="imagen in cambio.imagenes" :key="imagen.id">
            <b-card no-header class="galeria-imagen">
              <template v-if="isImagen(imagen.fileName)">
                <b-img fluid
                  @click="consultarImagen(imagen.url)"
                  :src="imagen.url"></b-img>
              </template>
              <template v-if="isPDF(imagen.fileName)">
                <div class="galeria-pdf">
                  <div @click="consultarPDF(imagen)">
                    <pdf 
                      :src="imagen.url"
                      :page="1"
                      :scale="0.8"/>
                  </div>
                </div>
              </template>
              <template v-if="isWord(imagen.fileName)">
                <div class="galeria-doc">
                  <i class="fa fa-file-word-o fa-2x" @click="downloadFile(imagen)"></i>
                  <label @click="downloadFile(imagen)">{{ imagen.fileName }}</label>
                </div>
              </template>
              <template v-if="isPowerPoint(imagen.fileName)">
                <div class="galeria-doc">
                  <i class="fa fa-file-powerpoint-o fa-2x" @click="downloadFile(imagen)"></i>
                  <label @click="downloadFile(imagen)">{{ imagen.fileName }}</label>
                </div>
              </template>
              <template v-if="isExcel(imagen.fileName)">
                <div class="galeria-doc">
                  <i class="fa fa-file-excel-o fa-2x" @click="downloadFile(imagen)"></i>
                  <label @click="downloadFile(imagen)">{{ imagen.fileName }}</label>
                </div>
              </template>
              <template v-if="isOtro(imagen.fileName)">
                <div class="galeria-doc">
                  <i class="fa fa-file fa-2x" @click="downloadFile(imagen)"></i>
                  <label @click="downloadFile(imagen)">{{ imagen.fileName }}</label>
                </div>
              </template>
              <div class="titulo">
                <h3 v-if="imagen.titulo != ''">{{ imagen.titulo }}</h3>
              </div>
            </b-card>
          </b-col>
        </b-row>
      </template>

      <hr v-if="index != cambios.length - 1">
    </div>

    <b-modal ref="imagenModal"
        hide-header
        hide-footer
        lazy
        modal-class="modalABM modalImagen">
      <app-imagen
        :url="selectedImageUrl"
        @close="closeImagen">
      </app-imagen>  
    </b-modal>

    <b-modal ref="pdfModal"
        hide-header
        hide-footer
        lazy
        modal-class="modalABM modalImagen modalPDF">
      <app-pdf-modal
        :filename="selectedFilename"
        :url="selectedImageUrl"
        @close="closePDF">
      </app-pdf-modal>  
    </b-modal>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>    
  </div>
</template>

<script>
import Imagen from  '../shared/imagenModal.vue';
import PdfModal from  '../shared/pdfModal.vue';
import pdf from 'vue-pdf'
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import moment from 'moment';

export default {
  name: 'BriefCambios',
  components: {
    appImagen: Imagen,
    appPdfModal: PdfModal,
    pdf,
    appMensaje: Mensaje,
  },
  mixins: [
    msjModal
  ],
  props: {
    cambios: {
      type: Array,
      default: []
    }
  },
  data () {
    return {
      key: 0,
      labelCols: 2,
      selectedFilename: '',
      selectedImageUrl: '',
      selectedBase64: '',

    }
  },
  created() {
  },
  methods: {
    refresh() {
      this.key++;
    },
    isImagen(fileName) {
      let extension = fileName.slice(-3);
      if (extension.toLowerCase() == 'jpg' 
          || extension.toLowerCase() == 'png') {
        return true;
      }

      extension = fileName.slice(-4);
      if (extension.toLowerCase() == 'jpeg') {
        return true;
      }

      return false;
    },
    isPDF(fileName) {
      let extension = fileName.slice(-3);
      if (extension == 'pdf') {
        return true;
      }
      return false;
    },
    isWord(fileName) {
      let extension = fileName.slice(-3);
      if (extension.toLowerCase() == 'doc') {
        return true;
      }

      extension = fileName.slice(-4);
      if (extension.toLowerCase() == 'docx') {
        return true;
      }

      return false;
    },
    isPowerPoint(fileName) {
      let extension = fileName.slice(-3);
      if (extension.toLowerCase() == 'ppt') {
        return true;
      }

      extension = fileName.slice(-4);
      if (extension.toLowerCase() == 'pptx') {
        return true;
      }

      return false;
    },
    isExcel(fileName) {
      let extension = fileName.slice(-3);
      if (extension.toLowerCase() == 'xls') {
        return true;
      }

      extension = fileName.slice(-4);
      if (extension.toLowerCase() == 'xlsx') {
        return true;
      }

      return false;
    },
    isOtro(fileName) {
      return !this.isImagen(fileName)
        && !this.isPDF(fileName)
        && !this.isWord(fileName)
        && !this.isPowerPoint(fileName)
        && !this.isExcel(fileName);
    },
    existsfechaEntregaSolicitada(fechaEntrega) {
      if (moment(fechaEntrega).isValid()) {
        return moment(fechaEntrega).format('YYYY-MM-DD') != '1900-01-01';
      }
      return false;
    },
    consultarImagen(imageUrl) {
      this.selectedImageUrl = imageUrl;
      this.$refs.imagenModal.show();
    },
    closeImagen() {
      this.$refs.imagenModal.hide();
    },
    consultarPDF(file) {
      this.selectedImageUrl = file.url;
      this.selectedFilename = file.fileName;
      this.$refs.pdfModal.show();
    },
    closePDF() {
      this.$refs.pdfModal.hide();
    },
    downloadFile(file) {
      if (file.url) {
        fetch(file.url)
          .then(res => res.blob())
          .then(blob => {
            saveAs(blob, file.fileName);
          });
      }
    },    
    handleDownload() {
      console.log('handle')
    },

  },
}
</script>

<style>
  /* .brief-datos-cambios .cambios {
    margin-bottom: 30px;
  } */

  .brief-datos-cambios {
    /* border: 1px solid #ececec; */
    /* margin-left: calc(8.33336%); */
    padding: 15px 20px;
    min-height: 300px;
    max-height: 450px;
    overflow-y: auto;
  }
  .brief-datos-cambios p.titulo {
    font-size: 12px;
    font-weight: 400;
    margin-bottom: 5px;
  }
  .brief-datos-cambios p.titulo:first-of-type {
    font-weight: 600;
  }
  .brief-datos-cambios p.cambios {
    color: #73818f !important;
    font-size: 12px;
    margin-top: 20px;
    margin-bottom: 15px;
    white-space: pre-line;
  }
  .brief-datos-cambios hr {
    margin-bottom: 30px !important;
    margin-top: 30px !important;
  }

  /* .brief-datos-cambios .galeria-imagenes {
    min-height: 300px;
  } */

  .brief-datos-cambios .galeria-imagenes .galeria-imagen .card-body {
    /* max-height: 200px !important; */
    max-height: 120px !important;
    overflow: hidden;
  }
  .brief-datos-cambios .galeria-imagenes .galeria-pdf {
    cursor: pointer;
  }
  .brief-datos-cambios .galeria-imagenes .galeria-doc {
    display: block;
  }
  .brief-datos-cambios .galeria-imagenes .galeria-doc i,
  .brief-datos-cambios .galeria-imagenes .galeria-doc label {
    display: block;
    cursor: pointer;
  }
  .brief-datos-cambios .galeria-imagenes .galeria-doc i {
    color: rgb(20,76,129);
    margin-bottom: 10px;
  }
  .brief-datos-cambios .galeria-imagenes .galeria-doc label {
    margin-bottom: 20px;
  }
  .brief-datos-cambios .galeria-imagenes .titulo p {
    font-size: 0.8em;
  }
</style>
